module.exports = __webpack_public_path__ + "bd720ba033b8de6c928d71eedba81bb0.pdf";